var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSymptomFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "-4 -1 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-symptom-filled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-symptom-filled",
    fill: "#7F8BDB",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18803912,0.70558575 C7.44415318,0.290601824 7.88684039,0.0271379135 8.37419209,0 L14.0646733,0 C14.5062298,0 14.6786686,0.306997646 14.4457349,0.682970823 L8.88189722,9.64470138 L15.5736544,9.64470138 C16.0157762,9.64470138 16.1328085,9.91099215 15.8359875,10.2372125 L1.19508322,26.2525391 C0.896566177,26.573671 0.790841389,26.51148 0.956495736,26.101019 L5.70110761,14.4667694 L0.517200761,14.4667694 C0.337412084,14.4989956 0.155927288,14.4170165 0.0620753371,14.2598428 C-0.0317766137,14.102669 -0.0182076569,13.904223 0.095997729,13.7611836 L7.18803912,0.70558575 Z",
    id: "Stroke-1-Copy"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSymptomFilled);
export default __webpack_public_path__ + "static/media/icons-symptom-filled.4e5d2c67592426545b13b2b54053804d.svg";
export { ForwardRef as ReactComponent };